"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _useToggleState = _interopRequireDefault(require("../useToggleState"));

function Checkbox(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  var controller = (0, _useToggleState["default"])(props);

  var selectable = _react["default"].Children.only(children);

  selectable = _react["default"].cloneElement(selectable, (0, _objectSpread2["default"])({}, props, {
    selected: controller.value,
    onClick: function onClick() {
      controller.setValue(!controller.value);
    }
  }));
  return selectable;
} // TODO: accessibility


var _default = Checkbox;
exports["default"] = _default;